(function mainThemeScript($, Drupal) {
  // jQueryでSleepする方法
  function wait(sec) {
    // jQueryのDeferredを作成します。
    var objDef = new $.Deferred;
    setTimeout(function () {
      // sec秒後に、resolve()を実行して、Promiseを完了します。
      objDef.resolve(sec);
    }, sec * 1000);
    return objDef.promise();
  }

  Drupal.behaviors.plStarter = {
    attach(context) {
      $('html', context).addClass('js');

      // 要素の高さを揃える
      // card UI
      // safariの場合、cardとcard-linkの設定によりheightがjquery側で計算されなくなる為、
      // 判定処理とCSS変更処理の追加.
      // Safari
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1) {
        // Pattern-Labで設定されているHeight = 100% の削除
        $('.card-link').css('height', 'auto');
      } else {
        $('.row .card').matchHeight();
      }
      // 書誌詳細ページで巻号リンクをクリック後の処理
      $('.js-link_volume_number').click(function (event) {
        /* Act on the event */
        $('html:first,body:first').animate({scrollTop: 0}, '1');
        setTimeout('location.reload()', 1000);
      });
    }
  };

  // 全文取得
  Drupal.behaviors.getFullText = {
    attach(context) {
      var $viewer = $('#uv'),
        manifestsUri = $viewer.data('uri');

      $.getJSON(manifestsUri).done(function (data) {
        $(document).bind('uv.onCanvasIndexChanged uv.onOpenRightPanel', data, function (e, i) {
          var $component = $viewer.find('iframe').contents().find('.iiif-metadata-component'),
            $search = $viewer.find('iframe').contents().find('.search');
          if (typeof i === 'undefined') {
            i = parseInt($search.find('.autocompleteText').val()) - 1;
          }

          wait(1).done(function () {
            $component.find('.item:visible').each(function () {
              var label = $(this).find('.label').text(),
                value = $(this).find('.value').html(),
                new_value,
                $valueObj;
              // console.log(label);

              if (label === '権利関係' && value === '[node:field_rights:entity:field_icon]') {
                $(this).remove();
              } else if (label === '二次利用方法') {
                if (value === '[node:field_guide_for_content_reuse]') {
                  $(this).remove();
                } else {
                  $valueObj = $(value);
                  var url = $valueObj.text(),
                    new_url = $('<a>').attr('href', url).get(0).href;
                  $valueObj.attr('href', url);  // UV で `a` タグの `href` 属性が落ちるバグに対するワークアラウンド
                  new_value = $valueObj.text(new_url);
                  var $gfcrValue = $(this).find('.value');
                  $gfcrValue.html(new_value);
                }
              } else if (label === 'Description') {
                var chars = e.data.sequences[0].canvases[i].images[0].resource.description,
                  $descriptionValue = $(this).find('.value');
                if (chars !== '[paragraph:field_description]') {
                  $descriptionValue.html(chars);
                } else {
                  $descriptionValue.empty();
                }
              }
            });
          });
        });
      });
    }
  };

  Drupal.behaviors.disableSubmitButtonDoubleClick = {
    attach: function attach(context) {
      $('#views-exposed-form-solr-search-content-page-1', context).on('submit', function () {
        $(this).find(':submit').prop('disabled', true);
      });
    }
  };
}(jQuery, Drupal));
